import React, { useEffect, useState } from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import ReportesContables from "../components/ReportesContables";
import API from "../api/api";

export default function BackofficeFacturas() {
  const [facturas, setFacturas] = useState([]);
  const [operaciones, setOperaciones] = useState([]);
  const [motivosRechazo, setMotivosRechazo] = useState({});
  const [parametros, setParametros] = useState({
    tasa_min: "0.01",
    tasa_max: "0.30",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [procesandoId, setProcesandoId] = useState(null);

  const cargarDatos = async () => {
    try {
      setError("");
      const token = localStorage.getItem("access");
      console.log("ADMIN TOKEN PRESENTE:", Boolean(token));

      const [resFacturas, resOperaciones, resParametros] = await Promise.all([
        API.get("/admin/facturas/"),
        API.get("/admin/operaciones/pendientes/"),
        API.get("/admin/parametros-financieros/"),
      ]);

      console.log("FACTURAS RESPONSE:", resFacturas.data);
      console.log("OPERACIONES RESPONSE:", resOperaciones.data);
      console.log("PARAMETROS RESPONSE:", resParametros.data);

      setFacturas(resFacturas.data || []);
      setOperaciones(resOperaciones.data || []);
      setParametros({
        tasa_min: String(resParametros.data?.tasa_min || "0.01"),
        tasa_max: String(resParametros.data?.tasa_max || "0.30"),
      });
    } catch (err) {
      console.log("ERROR:", err);
      console.error("Error cargando backoffice:", err);
      setError(
        err.response?.data?.detail ||
          err.response?.data?.error ||
          "No se pudo cargar el backoffice."
      );
    } finally {
      setLoading(false);
    }
  };

  const guardarParametros = async () => {
    try {
      setProcesandoId("parametros");
      const res = await API.put("/admin/parametros-financieros/", {
        tasa_min: parametros.tasa_min,
        tasa_max: parametros.tasa_max,
      });
      setParametros({
        tasa_min: String(res.data.tasa_min),
        tasa_max: String(res.data.tasa_max),
      });
      setError("");
    } catch (err) {
      console.error("Error guardando parámetros financieros:", err);
      setError(
        err.response?.data?.detail ||
          err.response?.data?.error ||
          "No se pudieron guardar los parámetros financieros."
      );
    } finally {
      setProcesandoId(null);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  const actualizarFactura = async (id, accion) => {
    try {
      setProcesandoId(`factura-${id}`);
      await API.post(`/admin/facturas/${id}/${accion}/`);
      setFacturas((prev) => prev.filter((factura) => factura.id !== id));
      if (accion === "aprobar") {
        cargarDatos();
      }
    } catch (err) {
      console.error(`Error al ${accion} factura:`, err);
      setError(
        err.response?.data?.detail ||
          err.response?.data?.error ||
          `No se pudo ${accion} la factura.`
      );
    } finally {
      setProcesandoId(null);
    }
  };

  const enviarConformidadFactura = async (id) => {
    try {
      setProcesandoId(`conformidad-${id}`);
      const res = await API.post(`/admin/facturas/${id}/enviar-conformidad/`);
      setFacturas((prev) =>
        prev.map((factura) => (factura.id === id ? res.data : factura))
      );
      setError("");
      alert("Conformidad enviada al emisor original.");
    } catch (err) {
      console.error("Error enviando conformidad:", err);
      setError(
        err.response?.data?.detail ||
          err.response?.data?.error ||
          "No se pudo enviar la conformidad."
      );
    } finally {
      setProcesandoId(null);
    }
  };

  const aprobarOperacion = async (id) => {
    try {
      setProcesandoId(`operacion-${id}`);
      const res = await API.post(`/admin/operaciones/${id}/aprobar/`);
      setOperaciones((prev) => prev.filter((operacion) => operacion.id !== id));
      setError("");
      if (res.data?.contrato_enviado) {
        alert("Venta aprobada y contrato enviado por correo.");
      } else {
        alert("Venta aprobada. El contrato no pudo enviarse por correo.");
      }
    } catch (err) {
      console.error("Error aprobando operación:", err);
      setError(
        err.response?.data?.detail ||
          err.response?.data?.error ||
          "No se pudo aprobar la operación."
      );
    } finally {
      setProcesandoId(null);
    }
  };

  const rechazarOperacion = async (id) => {
    const motivo = (motivosRechazo[id] || "").trim();

    if (!motivo) {
      setError("Debe indicar el motivo de rechazo para la venta.");
      return;
    }

    try {
      setProcesandoId(`operacion-${id}`);
      await API.post(`/admin/operaciones/${id}/rechazar/`, { motivo });
      setOperaciones((prev) => prev.filter((operacion) => operacion.id !== id));
      setMotivosRechazo((prev) => {
        const next = { ...prev };
        delete next[id];
        return next;
      });
      setError("");
      alert("Venta rechazada correctamente.");
    } catch (err) {
      console.error("Error rechazando operación:", err);
      setError(
        err.response?.data?.detail ||
          err.response?.data?.error ||
          "No se pudo rechazar la operación."
      );
    } finally {
      setProcesandoId(null);
    }
  };

  if (loading) {
    return <p className="text-center text-primary mt-10">Cargando backoffice...</p>;
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-primary">Backoffice</h1>
          <p className="text-slate-600">
            Revise facturas pendientes y ventas listas para aprobación final.
          </p>
        </div>

        <div className="flex gap-2">
          <Button
            className="bg-slate-700 hover:bg-slate-800"
            onClick={() => window.open("https://ekuatia.set.gov.py/consultas/", "_blank", "noopener,noreferrer")}
          >
            Verificar en SET
          </Button>
          <Button className="bg-slate-600 hover:bg-slate-700" onClick={cargarDatos}>
            Actualizar
          </Button>
        </div>
      </div>

      {error && (
        <Card className="border border-red-200 bg-red-50 text-red-700">
          {error}
        </Card>
      )}

      <ReportesContables />

      <Card className="space-y-4">
        <div>
          <h2 className="text-lg font-semibold text-primary">
            Parámetros Financieros
          </h2>
          <p className="text-sm text-slate-600">
            Ajuste los límites de descuento permitidos para validar ofertas de factoring.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div>
            <label className="text-sm font-medium">Descuento mínimo</label>
            <input
              type="number"
              step="0.000001"
              className="border rounded p-2 w-full"
              value={parametros.tasa_min}
              onChange={(e) =>
                setParametros((prev) => ({ ...prev, tasa_min: e.target.value }))
              }
            />
          </div>

          <div>
            <label className="text-sm font-medium">Descuento máximo</label>
            <input
              type="number"
              step="0.000001"
              className="border rounded p-2 w-full"
              value={parametros.tasa_max}
              onChange={(e) =>
                setParametros((prev) => ({ ...prev, tasa_max: e.target.value }))
              }
            />
          </div>
        </div>

        <div className="flex justify-end">
          <Button
            className="bg-primary text-white"
            disabled={procesandoId === "parametros"}
            onClick={guardarParametros}
          >
            {procesandoId === "parametros" ? "Guardando..." : "Guardar parámetros"}
          </Button>
        </div>
      </Card>

      <Card>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-primary">
            Facturas Pendientes ({facturas.length})
          </h2>
        </div>

        {facturas.length === 0 ? (
          <p className="text-slate-500">No hay facturas pendientes de revisión.</p>
        ) : (
          <div className="overflow-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b text-left">
                  <th className="py-2 pr-4">Usuario</th>
                  <th className="py-2 pr-4">RUC</th>
                  <th className="py-2 pr-4">Monto</th>
                  <th className="py-2 pr-4">CDC</th>
                  <th className="py-2 pr-4">Finanzas</th>
                  <th className="py-2 pr-4">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {facturas.map((factura) => (
                  <tr key={factura.id} className="border-b align-top">
                    <td className="py-3 pr-4">
                      <div className="font-medium text-slate-800">
                        {factura.usuario_nombre || "Sin nombre"}
                      </div>
                      <div className="text-xs text-slate-500">
                        {factura.usuario_email}
                      </div>
                    </td>
                    <td className="py-3 pr-4">{factura.ruc_emisor || "-"}</td>
                    <td className="py-3 pr-4">
                      {Number(factura.monto_total || 0).toLocaleString("es-PY")} Gs
                    </td>
                    <td className="py-3 pr-4 break-all max-w-xs">{factura.cdc}</td>
                    <td className="py-3 pr-4 text-xs text-slate-600">
                      <div>{factura.email_finanzas_emisor_original || "-"}</div>
                      <div>{factura.email_finanzas_receptor_original || "-"}</div>
                      <div className={factura.conformidad_enviada ? "text-emerald-700 font-semibold" : "text-amber-700 font-semibold"}>
                        {factura.conformidad_enviada
                          ? "Conformidad enviada"
                          : "Conformidad pendiente"}
                      </div>
                    </td>
                    <td className="py-3 pr-4">
                      <div className="flex flex-col md:flex-row gap-2">
                        <Button
                          className="bg-moss hover:bg-moss/90"
                          disabled={
                            factura.conformidad_enviada ||
                            procesandoId === `conformidad-${factura.id}`
                          }
                          onClick={() => enviarConformidadFactura(factura.id)}
                        >
                          Enviar conformidad
                        </Button>
                        <Button
                          className="bg-emerald-600 hover:bg-emerald-700"
                          disabled={
                            !factura.conformidad_enviada ||
                            procesandoId === `factura-${factura.id}`
                          }
                          onClick={() => actualizarFactura(factura.id, "aprobar")}
                        >
                          Aprobar
                        </Button>
                        <Button
                          className="bg-red-600 hover:bg-red-700"
                          disabled={procesandoId === `factura-${factura.id}`}
                          onClick={() => actualizarFactura(factura.id, "rechazar")}
                        >
                          Rechazar
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>

      <Card>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-primary">
            Ventas Pendientes de Aprobación ({operaciones.length})
          </h2>
        </div>

        {operaciones.length === 0 ? (
          <p className="text-slate-500">No hay ventas pendientes para backoffice.</p>
        ) : (
          <div className="space-y-4">
            {operaciones.map((operacion) => (
              <div key={operacion.id} className="border rounded p-4 bg-cream/55">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                  <p><b>Publicación:</b> {operacion.publicacion?.titulo}</p>
                  <p><b>Monto oferta:</b> {Number(operacion.oferta?.monto || 0).toLocaleString("es-PY")} Gs</p>
                  <p><b>Cliente:</b> {operacion.cliente?.email}</p>
                  <p><b>Comprador:</b> {operacion.comprador?.email}</p>
                  <p><b>Comprador confirmó:</b> {operacion.comprador_acepto_venta ? "Sí" : "No"}</p>
                  <p><b>Vendedor confirmó:</b> {operacion.vendedor_acepto_venta ? "Sí" : "No"}</p>
                  <p><b>Email finanzas actual:</b> {operacion.email_finanzas_receptor_actual || "-"}</p>
                  <p><b>Estado backoffice:</b> {operacion.estado_backoffice}</p>
                </div>

                {operacion.comprobante_transferencia_url && (
                  <p className="mt-3 text-sm">
                    <b>Comprobante:</b>{" "}
                    <a
                      href={operacion.comprobante_transferencia_url}
                      target="_blank"
                      rel="noreferrer"
                      className="text-moss underline"
                    >
                      Ver adjunto
                    </a>
                  </p>
                )}

                <div className="mt-4 space-y-3">
                  <textarea
                    className="border rounded p-2 w-full text-sm"
                    rows={3}
                    placeholder="Motivo de rechazo si detecta datos erróneos o inconsistencias..."
                    value={motivosRechazo[operacion.id] || ""}
                    onChange={(e) =>
                      setMotivosRechazo((prev) => ({
                        ...prev,
                        [operacion.id]: e.target.value,
                      }))
                    }
                  />

                  <div className="flex flex-col md:flex-row gap-2">
                  <Button
                    className="bg-emerald-600 hover:bg-emerald-700"
                    disabled={procesandoId === `operacion-${operacion.id}`}
                    onClick={() => aprobarOperacion(operacion.id)}
                  >
                    Aprobar venta
                  </Button>
                  <Button
                    className="bg-red-600 hover:bg-red-700"
                    disabled={procesandoId === `operacion-${operacion.id}`}
                    onClick={() => rechazarOperacion(operacion.id)}
                  >
                    Rechazar venta
                  </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
